import { DataQualityWarningGraphqlOrIndicator, WarningStatusIcon } from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import { Dictionary } from '@tableau/widgets-datagrid/lib/src/Utils';
import React from 'react';

import { CatalogContentTypes } from '~src/catalog/CatalogContentType';
import { CatalogTelemetryProvider } from '~src/catalog/DataCatalogTelemetry';
import { IDataQualityIndicator } from '~src/catalog/serverApi/types/IDataQualityIndicator';

const IconStyle: React.CSSProperties = {
    position: 'relative',
    left: '13.4px',
    top: '2px'
};

function convertDataQualityWarningsFromRowDataToIDataQualityIndicator(oldWarnings: readonly DataQualityWarningGraphqlOrIndicator[] | undefined): IDataQualityIndicator[] | undefined {
    const newWarnings: IDataQualityIndicator[] | undefined = oldWarnings?.map((warning: DataQualityWarningGraphqlOrIndicator) => {
        const owner = 'owner' in warning ? warning.owner : {
                  authId: '',
                  displayName: warning.author?.name ? warning.author?.name : '',
                  username: warning.author?.username ? warning.author?.username : '',
                  domainName: warning.author?.domain ? warning.author?.domain : '',
                  id: '',
                };
        const newWarning: IDataQualityIndicator = {
            isActive: warning.isActive,
            isSevere: warning.isSevere,
            type: 'type' in warning ? warning.type : warning.warningType,
            id: 'vizportalId' in warning ? warning.vizportalId : '',
            message: warning.message || '',
            updatedAt: (new Date(warning.updatedAt)),
            owner: owner,
        };
        return newWarning;
    });
    return newWarnings;
}

/**
 * TODO: delete this duplicate implementation
 */
/** @deprecated TFS1478812 */
export function CreateDataQualityWarningCell(siteUrls: SiteUrls, hasDataQualityIndicator: (row: DataGrid.Row) => boolean):
React.Factory<BodyCell.Props> {
    return React.createFactory(class extends React.Component<BodyCell.Props, any> {
        getWarningsFromRowData = (r: Dictionary<any>) => {
            if (r.dataQualityWarnings === undefined || r.dataQualityWarnings.length === 0){
                return undefined;
            }else{
                return r.dataQualityWarnings;
            }
        };

        getNameFromRowData = (r: Dictionary<any>): string => {
            if (r.name === undefined){
                return '';
            }
            return r.name;
        };
        getAssetUrlFromRowData = (r: Dictionary<any>) => {
            if(r.contentType === CatalogContentTypes.table) {
                return siteUrls.catalogTableUrl(r.id);
            } else if(r.contentType === CatalogContentTypes.database) {
                return siteUrls.catalogDatabaseUrl(r.id);
            }
        };
        getDataQualityIndicatorAssetTypeFromRowData = (r: Dictionary<any>) => {
            if(r.contentType === CatalogContentTypes.table) {
                return 'DatabaseTable';
            } else if(r.contentType === CatalogContentTypes.database) {
                return 'DatabaseServer';
            }
        };

        getsiteUrls = () => {return siteUrls;};
        render() {
            const oldWarnings = this.getWarningsFromRowData(this.props.row.data);
            const newWarnings: IDataQualityIndicator[] | undefined = convertDataQualityWarningsFromRowDataToIDataQualityIndicator(oldWarnings);
            return (
            <div style={IconStyle}>
              <CatalogTelemetryProvider>
                <WarningStatusIcon
                iconOnly={true}
                kind={'vizportal'}
                upstreamWarnings={[]}
                subjectArea={this.getDataQualityIndicatorAssetTypeFromRowData(this.props.row.data)}
                anchoredAsset={{
                  assetName: this.getNameFromRowData(this.props.row.data),
                  assetType: this.getDataQualityIndicatorAssetTypeFromRowData(this.props.row.data),
                  assetUrl: _ => this.getAssetUrlFromRowData(this.props.row.data)
                }}
                anchoredWarnings={newWarnings ||  []}
                urls={this.getsiteUrls()}
                linksDisabled={true}
                source={'CreateDataQualityWarningCell'}
                />
                </CatalogTelemetryProvider>
            </div>
            );
        }
    });
}
